
import { prop, Vue } from "vue-class-component";

class Props {
  fill = prop<boolean>({
    default: true,
    type: Boolean
  });
}
export default class Calendar extends Vue.with(Props) {}
